export const isSuccessResponse = (status, body) => {
    return status >= 200 && status < 300 && body?.ok !== false
}

export const getResponseData = (body) => {
    if (body && Object.prototype.hasOwnProperty.call(body, 'data')) {
        return body.data || {}
    }

    return body || {}
}

export const getResponseMessage = (body) => {
    return body?.message || ''
}

export const getErrorMessage = (error) => {
    return error?.response?.data?.message || error?.response?.data?.error || error?.message || ''
}
